import { render, staticRenderFns } from "./ManagerInfo.vue?vue&type=template&id=387e19b8"
import script from "./ManagerInfo.vue?vue&type=script&lang=js"
export * from "./ManagerInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('387e19b8')) {
      api.createRecord('387e19b8', component.options)
    } else {
      api.reload('387e19b8', component.options)
    }
    module.hot.accept("./ManagerInfo.vue?vue&type=template&id=387e19b8", function () {
      api.rerender('387e19b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/quick/ManagerInfo.vue"
export default component.exports